import Backbone from 'backbone'
import $ from 'jquery'
import template from './broadcast-alert.hbs'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import appDisplay from 'scoreboard/components/app-display'
import BroadcastAlertConfirmation from './broadcast-alert-confirmation'
import AlertForm from './alert-form'
/**
 * The Admin | Broadcast Alert Panel
 */
var BroadcastAlert = Backbone.View.extend({

	className: 'admin broadcast-alert table-hack display-layout',

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.alertPreferences.broadcastAlert'),
			mobileGearHidden: true
		}).render().el, template())

		// #54608 - extract out the controls to AlertForm to allow reuse
		this.renderAlertForm()
		return this
	},

	renderAlertForm: function() {
		this.alertForm = new AlertForm({
			guardOptions: {
				messages: {
					prompt: i18n.get('admin.alertPreferences.broadcast.guard.prompt'),
					promptWarning: i18n.get('admin.alertPreferences.broadcast.guard.promptConfirm'),
					save: i18n.get('common.send'),
					dontSave: i18n.get('common.dontSend')
				}
			},
			displaySubmitOptions: true,
			url: 'api/alerts/recipients',
			onSubmit: data => {
				$.post('api/alerts/broadcast', JSON.stringify(data))
					.done(() => {
						appDisplay.dialog(new BroadcastAlertConfirmation())
					})
					.always(() => {
						this.alertForm.clearForm()
						// #19073 - Needed for IE to be in the correct dirty state.  Without nextTick here
						// change events get queued up behind the formView.start causing the guard to always
						// activate, even if navigating away immediately after sending an alert
						process.nextTick(() => this.alertForm.formView.start())
					})
			}
		})
		this.$('.panel-content').append(this.alertForm.el)
		this.alertForm.render()
	},

	autoRemove: true
})

export default BroadcastAlert

BroadcastAlert.__filename__ = 'admin/alerts/broadcast-alert.js'
